import { FC } from 'react';

import { ContentSlotType } from '../../models/Content';
import { ContentBlock } from '../ContentBlock/ContentBlock';
import { transformContentSlot } from './transformers';

interface Props {
    contentItem: ContentSlotType;
}

export const ContentSlotBase: FC<Props> = ({ contentItem }: Props) => {
    const transformedContentItem = transformContentSlot(contentItem);

    return (
        <>
            {transformedContentItem.contents?.map((content) => (
                <ContentBlock key={content.sys.id} contentItem={content} />
            ))}
        </>
    );
};
